import React from "react";
import "../components/common/loaders/SkeletonLoaders.css";

const SliderLoader = ({ height = 280, style = {} }) => {
  return (
    <div
      className="shz-skeleton-shimmer"
      style={{
        width: "100%",
        minHeight: height,
        borderRadius: "16px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        margin: "0 auto",
        ...style,
      }}
    />
  );
};

export default SliderLoader;
